import { createRegisterAction, createUnregisterAction, Feature } from '@omaze/feature';
import React, { ReactElement, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { DynamicModuleLoader } from 'redux-dynamic-modules';
import { ISagaModule } from 'redux-dynamic-modules-saga';

import { IPropsWithChildren } from '../interfaces/IPropsWithChildren';

import { displayName } from './App.qa';

export interface IAppProps extends IPropsWithChildren {
    featureFlags: { [key: string]: boolean };
    flag?: string;
    modules: ISagaModule<any>[];
}

export function App (props: IAppProps): ReactElement {
    const {
        children,
        featureFlags,
        flag,
        modules,
    }: IAppProps = props;

    const dispatch: Dispatch = useDispatch();

    useEffect((): () => void => {
        dispatch(createRegisterAction(featureFlags));

        return (): void => {
            dispatch(createUnregisterAction(featureFlags));
        };
    }, []);

    const app: ReactElement = (
        <DynamicModuleLoader modules={modules}>
            {children}
        </DynamicModuleLoader>
    );

    if (flag) {
        return <Feature flag={flag}>{app}</Feature>;
    }

    return app;
}

App.displayName = displayName;
